import { useMutation, useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchDialogData, upsertMyLibraryNote, } from "../api/titleLibraryNoteService";
var dialogDataKey = function (titleId) {
    return ["title-library-note-dialog", titleId];
};
export var useTitleLibraryNoteDialog = function (titleId, enabled) {
    var kyInstance = useOkapiKy();
    return useQuery(dialogDataKey(titleId), function () { return fetchDialogData(kyInstance, titleId); }, { enabled: enabled && Boolean(titleId), cacheTime: 60000 });
};
export var useUpsertMyLibraryNote = function (titleId) {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (text) { return upsertMyLibraryNote(kyInstance, titleId, text); }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["title", titleId]);
            queryClient.invalidateQueries(["title-detail", titleId]);
            queryClient.invalidateQueries(dialogDataKey(titleId));
        },
    });
};
